import React from 'react'

const Theme4Nophotocouple = ({values}) => {

   const renderPersonCard = ({
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  }) => {
    return (
      <div className="t4-preview-single-couple-container">

        <div className="t4-preview-couple-grandparents">
           {grandParentsName && (
  <p>
    {grandParentsPrefix} {grandParentsName}
  </p>
)}
        </div>

        <h1 className="t4-preview-couple-name">
          {fullname}
        </h1>

        <div className="t4-preview-couple-parents">
            {parentsName && (
  <p>
    {parentprefix} {parentsName}
  </p>
)}
        </div>

      </div>
    );
  };

  const groomCard = () =>
    renderPersonCard({
      fullname: values.groomFullName || "Groom Full Name",
      parentprefix: values.groomParentsPrefix,
      parentsName: values.groomParents,
      grandParentsPrefix: values.groomGrandParentsPrefix,
      grandParentsName: values.groomGrandParents,
    });

  const brideCard = () =>
    renderPersonCard({
       fullname: values.brideFullName || "Bride Full Name",
      parentprefix: values.brideParentsPrefix,
      parentsName: values.brideParents,
      grandParentsPrefix: values.brideGrandParentsPrefix,
      grandParentsName: values.brideGrandParents,
    });


  return (
   <div className="t4-couple-section t4-no-photo-couple">
     <img
        src="/theme4-couple-section-decor.png"
        alt=""
        className="theme4-preview-photo-couple-pattern theme4-preview-photo-couple-pattern-top"
      />
       <div className="preview-photo-couple-container"  >
          <div className="theme4-preview-noPhoto-couple-content">
               <h1 className="t4-preview-couple-heading">
           {values?.sectionHeading}
          </h1>
           <div className="t4-preview-couple-wrapper">
              {values.displayOrder==="groomFirst"?(
                          <>
                              {groomCard()}
                              <span className="t4-preview-couple-divider">
                        &
                    </span>
                            {brideCard()}
                          </>
                        ): (
                          <>
                              {brideCard()}
                                 <span className="t4-preview-couple-divider">
                        &
                    </span>
                    {groomCard()}
                          </>
                        )}
          
           </div>
          </div>
       </div>

          <img
        src="/theme4-couple-section-decor.png"
        alt=""
        className="theme4-preview-photo-couple-pattern theme4-preview-photo-couple-pattern-bottom"
      />
   </div>
  )
}

export default Theme4Nophotocouple